<!-- Se peude eliminar el agente -->
<div>
  <h2 id="title" class="paragraph-01-bold">
    ¿Este proceso no es reversible. Esta seguro de que desea eliminar este
    agente?
  </h2>
</div>

<!-- No se peude eliminar el agente -->
<!-- <div *ngIf="!deleteable">
  <h2 id="title" class="subheading-02-bold">
    No es posible eliminar al agente seleccionado.
  </h2>
  <p class="paragraph-01-regular">Motivo: Motivo del SP</p>
</div> -->